var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.28,
    height: 35.068,
    viewBox: "0 0 28.28 35.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF_V2",
    transform: "translate(-221 -176.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M312.348,220.848H288.24V186.86h19.409l4.7,4.039Z",
    transform: "translate(-63.608 -9.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236_-_Outline",
    "data-name": "Path 236 - Outline",
    d: "M302.889,211.928H278.78a.54.54,0,0,1-.54-.54V177.4a.54.54,0,0,1,.54-.54h19.409a.54.54,0,0,1,.352.131l4.7,4.039a.54.54,0,0,1,.188.41v29.949A.54.54,0,0,1,302.889,211.928Zm-23.568-1.08h23.028V181.687l-4.36-3.747H279.32Z",
    transform: "translate(-54.148)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M642.83,187.455H639.8a2.217,2.217,0,0,1-2.214-2.214v-2.38a.54.54,0,0,1,1.08,0v2.38a1.135,1.135,0,0,0,1.134,1.134h3.025a.54.54,0,0,1,0,1.08Z",
    transform: "translate(-394.089 -5.165)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_23",
    "data-name": "Line 23",
    d: "M5.138-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h14.6a.54.54,0,0,1,.54.54A.54.54,0,0,1,5.138-8.92Z",
    transform: "translate(238.883 193.356)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_24",
    "data-name": "Line 24",
    d: "M5.138-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h14.6a.54.54,0,0,1,.54.54A.54.54,0,0,1,5.138-8.92Z",
    transform: "translate(238.883 196.821)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_25",
    "data-name": "Line 25",
    d: "M5.138-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h14.6a.54.54,0,0,1,.54.54A.54.54,0,0,1,5.138-8.92Z",
    transform: "translate(238.883 200.287)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_26",
    "data-name": "Line 26",
    d: "M-2.21-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h7.25a.54.54,0,0,1,.54.54A.54.54,0,0,1-2.21-8.92Z",
    transform: "translate(246.231 203.753)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_27",
    "data-name": "Line 27",
    d: "M-2.21-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h7.25a.54.54,0,0,1,.54.54A.54.54,0,0,1-2.21-8.92Z",
    transform: "translate(246.231 207.218)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_28",
    "data-name": "Line 28",
    d: "M-2.21-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h7.25a.54.54,0,0,1,.54.54A.54.54,0,0,1-2.21-8.92Z",
    transform: "translate(246.231 210.684)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_29",
    "data-name": "Line 29",
    d: "M-2.21-8.92H-9.46A.54.54,0,0,1-10-9.46.54.54,0,0,1-9.46-10h7.25a.54.54,0,0,1,.54.54A.54.54,0,0,1-2.21-8.92Z",
    transform: "translate(246.231 214.15)",
    fill: "#172b46"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1336",
    "data-name": "Rectangle 1336",
    width: 12.629,
    height: 12.336,
    transform: "translate(221.587 193.384)",
    fill: "#de0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1336_-_Outline",
    "data-name": "Rectangle 1336 - Outline",
    d: "M-9.46-10H3.071a.54.54,0,0,1,.54.54V3.071a.54.54,0,0,1-.54.54H-9.46a.54.54,0,0,1-.54-.54V-9.46A.54.54,0,0,1-9.46-10ZM2.531-8.92H-8.92V2.531H2.531Z",
    transform: "translate(231 202.747)",
    fill: "#de0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M243.9,561.357v-4.789a.1.1,0,0,1,.107-.107h1.537a1.646,1.646,0,1,1,0,3.281h-.515v1.615a.1.1,0,0,1-.107.107h-.915A.1.1,0,0,1,243.9,561.357Zm1.615-2.616c.379,0,.729-.122.729-.636s-.35-.643-.729-.643h-.486v1.28Z",
    transform: "translate(-21.663 -359.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M314.17,561.357v-4.789a.1.1,0,0,1,.107-.107h1.551a2.5,2.5,0,1,1,0,5h-1.551a.1.1,0,0,1-.107-.107Zm1.644-.893a1.5,1.5,0,0,0,0-3H315.3v3h.515Z",
    transform: "translate(-88.138 -359.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M399.66,561.357v-4.789a.1.1,0,0,1,.107-.107h2.552a.1.1,0,0,1,.107.107v.786a.1.1,0,0,1-.107.107h-1.53v.944h1.437a.1.1,0,0,1,.108.108v.786a.1.1,0,0,1-.108.107H400.79v1.951a.1.1,0,0,1-.107.107h-.915A.1.1,0,0,1,399.66,561.357Z",
    transform: "translate(-169.01 -359.097)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDocument);
export default __webpack_public_path__ + "static/media/pdf-document.d29f371784705425764d53c3218f62d9.svg";
export { ForwardRef as ReactComponent };